import { defineComponent as _defineComponent } from 'vue'
interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFootnote',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})